function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import _$1 from "lodash";
import { v4 } from "uuid";
import React, { useContext } from "react";
import semver from "semver";
import ReactDOMServer from "react-dom/server";

function ownKeys(t, e) {
  var n,
      r = Object.keys(t);
  return Object.getOwnPropertySymbols && (n = Object.getOwnPropertySymbols(t), e && (n = n.filter(function (e) {
    return Object.getOwnPropertyDescriptor(t, e).enumerable;
  })), r.push.apply(r, n)), r;
}

function _objectSpread2(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? ownKeys(Object(n), !0).forEach(function (e) {
      _defineProperty(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : ownKeys(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function _createClass(e, t, n) {
  return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _defineProperty(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}

function _extends() {
  return (_extends = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n,
          r = arguments[t];

      for (n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  }).apply(this, arguments);
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && _setPrototypeOf(e, t);
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function _objectWithoutPropertiesLoose(e, t) {
  if (null == e) return {};

  for (var n, r = {}, i = Object.keys(e), a = 0; a < i.length; a++) {
    n = i[a], 0 <= t.indexOf(n) || (r[n] = e[n]);
  }

  return r;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};

  var n,
      r = _objectWithoutPropertiesLoose(e, t);

  if (Object.getOwnPropertySymbols) for (var i = Object.getOwnPropertySymbols(e), a = 0; a < i.length; a++) {
    n = i[a], 0 <= t.indexOf(n) || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  if (t && ("object" == _typeof(t) || "function" == typeof t)) return t;
  if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(e);
}

function _createSuper(n) {
  var r = _isNativeReflectConstruct();

  return function () {
    var e,
        t = _getPrototypeOf(n);

    return _possibleConstructorReturn(this, r ? (e = _getPrototypeOf(this).constructor, Reflect.construct(t, arguments, e)) : t.apply(this, arguments));
  };
}

function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableSpread();
}

function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) return _arrayLikeToArray(e);
}

function _iterableToArray(e) {
  if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
}

function _unsupportedIterableToArray(e, t) {
  var n;
  if (e) return "string" == typeof e ? _arrayLikeToArray(e, t) : "Map" === (n = "Object" === (n = Object.prototype.toString.call(e).slice(8, -1)) && e.constructor ? e.constructor.name : n) || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(e, t) : void 0;
}

function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _Parsing$2,
    _Parsing$1,
    _Parsing,
    _Transistor$Parsers,
    Mark = function () {
  function n() {
    _classCallCheck(this, n);
  }

  return _createClass(n, null, [{
    key: "Stamp",
    value: function value(e, t) {
      return _objectSpread2({
        __mark: e
      }, t);
    }
  }, {
    key: "Type",
    value: function value(e) {
      return (_$1.isPlainObject(e) || _$1.isFunction(e)) && "__mark" in e ? n[e.__mark] : n.None;
    }
  }, {
    key: "Valid",
    value: function value(e) {
      return !n.is(e, n.None);
    }
  }, {
    key: "is",
    value: function value(e, t) {
      return n.Type(e) == t;
    }
  }]), n;
}(),
    _excluded$1 = (_$1.each(["None", "Statement", "Conclusion", "Always", "Reference", "Request", "Definition", "Component", "Board", "Transform"], function (e) {
  Mark.Type[e] = e, Mark[e] = e;
}), ["view", "edit", "get", "raw", "prepare", "batch", "modes"]),
    _excluded2 = ["children", "field", "value", "MODE"],
    _excluded3 = ["modes", "__mark"],
    define$1 = function define$1(e) {
  var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : Mark.Definition,
      i = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : function (e, t) {
    function n(e) {
      var t = e.children,
          n = e.field,
          r = e.value,
          i = e.MODE,
          e = _objectWithoutProperties(e, _excluded2),
          i = i ? u[i] : u.view || u.edit;

      return e.contents || (e.contents = t), _$1.isFunction(i) ? /*#__PURE__*/React.createElement(i, _extends({
        field: n,
        value: null != r ? r : globalThis.Board ? _$1.get(globalThis.Board.Value, globalThis.Board.Path.concat(n ? [n] : [])) : null
      }, e), t) : _$1.isPlainObject(i) ? /*#__PURE__*/React.createElement(e.Subschema, {
        field: n,
        schematic: [i, e]
      }) : null;
    }

    var t = t = _$1.isFunction(t) ? {
      edit: t
    } : t,
        r = t.view,
        i = t.edit,
        a = t.get,
        o = t.raw,
        s = t.prepare,
        c = t.batch,
        u = t.modes,
        t = _objectWithoutProperties(t, _excluded$1),
        u = u || {},
        r = (r && (u.view = r), i && (u.edit = i), _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, u.view || {}), e), t), {}, {
      get: a,
      raw: o,
      prepare: s,
      batch: c,
      modes: _objectSpread2(_objectSpread2({}, e.modes), u)
    }));

    return _$1.each(r, function (e, t) {
      void 0 !== e && (n[t] = e);
    }), n;
  },
      a = {
    __mark: t,
    displayName: e = _$1.isArray(e) ? e[0] : e
  };
  return function e() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) {
      n[r] = arguments[r];
    }

    return 1 == n.length && (n = n[0]), _$1.isString(n) ? (a.version = n, e) : i(a, n);
  };
},
    board$1 = function board$1(e) {
  return define$1(e, Mark.Board, function (n, r) {
    var e,
        i = {},
        a = !1;
    return _$1.isArray(r) && (_$1.isPlainObject(r[e = 0]) && (n.components = r[0], e++), r = r.length > 1 + e ? (_$1.isFunction(r[e]) ? a = r[e] : i = r[e], r[e + 1]) : r[e]), _$1.isFunction(r) && (r = r.bind(i)), function (e) {
      globalThis.UI || (globalThis.UI = n.components), globalThis.Board || (globalThis.Board = {
        Value: {},
        Evaluate: function Evaluate(e, t) {
          return Board$1.Evaluate(e, t, n.components);
        }
      }), _$1.isFunction(a) && (i = a(e), a = !1);

      var t = _$1.isFunction(r) ? r(_objectSpread2(_objectSpread2({}, e), {}, {
        Self: i
      }, i)) : r,
          e = _objectSpread2(_objectSpread2(_objectSpread2({}, e), n), t);

      return /*#__PURE__*/React.createElement(Board$1, e);
    };
  });
},
    ui$1 = function ui$1(e) {
  function n(e) {
    return [t, _$1.isPlainObject(e) ? e : {
      definition: e
    }];
  }

  var t = Mark.Stamp(Mark.Component, {
    path: e && (_$1.isArray(e) ? e.join("") : e)
  }),
      r = n;
  return _$1.each(t, function (e, t) {
    return r[t] = e;
  }), r.of = function (e) {
    return t.contents = _$1.isArray(e) && "raw" in e ? e[0] : e, _$1.each(t, function (e, t) {
      return n[t] = e;
    }), n;
  }, r;
},
    Components = {
  Scaffolding: {
    define: define$1,
    board: board$1,
    ui: ui$1
  },
  Parsing: (_defineProperty(_Parsing$2 = {}, Mark.Definition, function (e, t, n, r) {
    var i = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : "edit",
        a = e.value,
        o = a.modes;
    return a.__mark, _objectWithoutProperties(a, _excluded3), o[i] || o.edit;
  }), _defineProperty(_Parsing$2, Mark.Component, function (e, t, n, r) {
    var i,
        a = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : "edit",
        o = e.value.path.split("|"),
        s = o[0],
        o = (2 <= o.length && (a = o[1]), e.value.contents),
        c = _$1.get(r, Path.Parse(s, t, n, e.path));

    return c || (i = e.resolve(s, t, n)) && (c = _$1.get(r, Path.Parse(i, t, n, e.path))), c && Mark.is(c, Mark.Definition) && ((i = _$1.pick(c, ["displayName", "version", "migrations"])).migrations = _$1.pick(i.migrations, _$1.keys(i.migrations).sort(semver.compare)), c = [c.modes[a] || c.modes.edit, {
      __definition: i
    }]), c || console.warn('Component with path: "'.concat(s, '" not found!')), o ? [c, {
      __contents: _$1.isString(o) && e.resolve(o, t, n) || o
    }] : c;
  }), _Parsing$2)
},
    Proofs$1 = {
  present: function present(e) {
    return !!_$1.isNumber(e) || (_$1.isObject(e) || _$1.isString(e) ? !_$1.isEmpty(e) : !_$1.isNil(e));
  },
  equal: {
    to: function to(e) {
      for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) {
        n[r - 1] = arguments[r];
      }

      return n.includes(e);
    }
  },
  matching: function matching(n) {
    for (var e = arguments.length, t = new Array(1 < e ? e - 1 : 0), r = 1; r < e; r++) {
      t[r - 1] = arguments[r];
    }

    return _$1.reduce(t, function (e, t) {
      return !!e && t.test(n);
    }, !0);
  },
  email: function email(e) {
    return Proofs$1.matching(e, /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  },
  link: function link(e) {
    try {
      return url = new URL(string), !0;
    } catch (e) {
      return !1;
    }
  },
  zip: function zip(e) {
    return Proofs$1.matching(e, /^\d{5}[-\s]?(?:\d{4})?$/gm);
  },
  phone: function phone(e) {
    return Proofs$1.matching(e, /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g);
  },
  containing: function containing(n) {
    for (var e = arguments.length, t = new Array(1 < e ? e - 1 : 0), r = 1; r < e; r++) {
      t[r - 1] = arguments[r];
    }

    return _$1.reduce(t, function (e, t) {
      return !!e && (null == n ? void 0 : n.includes(t));
    }, !0);
  },
  below: function below(e, t) {
    return (_$1.isNumber(e) ? e : (null == e ? void 0 : e.length) || 0) < parseFloat(t);
  },
  above: function above(e, t) {
    return (_$1.isNumber(e) ? e : (null == e ? void 0 : e.length) || 0) > parseFloat(t);
  },
  at: {
    most: function most(e, t) {
      return (_$1.isNumber(e) ? e : (null == e ? void 0 : e.length) || 0) <= parseFloat(t);
    },
    least: function least(e, t) {
      return (_$1.isNumber(e) ? e : (null == e ? void 0 : e.length) || 0) >= parseFloat(t);
    }
  }
},
    Proofs = _objectSpread2({}, Proofs$1),
    Symbols = {
  when: "when",
  is: "is",
  isnt: "isnt",
  and: "and",
  or: "or"
},
    Conditions = function Conditions() {
  function e(e) {
    return Conjunctions(Mark.Stamp(Mark.Statement, {
      statement: [].concat(_toConsumableArray(c), _toConsumableArray(1 == e.length ? e : [e]))
    }));
  }

  var c = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [],
      u = 1 < arguments.length ? arguments[1] : void 0;
  return _$1.each([Symbols.is, Symbols.isnt], function (s) {
    function n(o) {
      return _$1.mapValues(Proofs, function (e, n) {
        function r(r) {
          return function () {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
              t[n] = arguments[n];
            }

            return Conjunctions(a(r, t));
          };
        }

        var i,
            a = function a(e) {
          var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [];
          return Mark.Stamp(Mark.Statement, {
            statement: [].concat(_toConsumableArray(c), [{
              query: s,
              proof: e,
              operands: t,
              path: (o ? o.join("") : u) || ""
            }])
          });
        };

        return _$1.isPlainObject(e) ? _$1.mapValues(e, function (e, t) {
          return r("".concat(n, ".").concat(t));
        }) : (i = Conjunctions(r(n)), _$1.each(a(n), function (e, t) {
          return i[t] = e;
        }), i);
      });
    }

    _$1.each(n(), function (e, t) {
      return n[t] = e;
    }), e[s] = n;
  }), e;
},
    Adverb = function Adverb(t) {
  function e(e) {
    return Conditions(t, e && e.join(""));
  }

  return e.is = Conditions(t)[Symbols.is], e.isnt = Conditions(t)[Symbols.isnt], e;
},
    Conjunctions = function Conjunctions(r) {
  return _$1.each([Symbols.and, Symbols.or], function (n) {
    return Object.defineProperty(r, n, {
      get: function get() {
        var e = r == Array ? [this[0].statement] : this.statement,
            t = Conditions([].concat(_toConsumableArray(e), [n]));
        return t.when = Adverb([].concat(_toConsumableArray(e), [n])), t;
      }
    });
  }), r.then = function () {
    var e = !(0 < arguments.length && void 0 !== arguments[0]) || arguments[0],
        t = Mark.Stamp(Mark.Conclusion, {
      condition: r == Array ? Mark.Stamp(Mark.Statement, this) : this,
      failure: !1,
      success: e
    });
    return t.otherwise = function (e) {
      return _objectSpread2(_objectSpread2({}, t), {}, {
        failure: e
      });
    }, t;
  }, r;
},
    Conditional = {
  Scaffolding: function Scaffolding() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    return Proofs = _objectSpread2(_objectSpread2({}, Proofs), e), {
      is: Conditions()[Symbols.is],
      isnt: Conditions()[Symbols.isnt],
      when: Adverb()
    };
  },
  Parsing: (_defineProperty(_Parsing$1 = {}, Mark.Statement, function (r, i, a) {
    function o(e, t) {
      var n = {};
      return _defineProperty(n, Symbols.and, function () {
        return !!e && t;
      }), _defineProperty(n, Symbols.or, function () {
        return !!t || e;
      }), n[s]();
    }

    var e = _$1.castArray(r.value.statement),
        s = Symbols.and;

    return _$1.reduce(e, function (e, t) {
      var n;
      return _$1.isArray(t) ? o(e, Conditional.Parsing[Mark.Statement](new Transistor$1(Mark.Stamp(Mark.Statement, {
        statement: t
      }), r.origin), a, i)) : _$1.isString(t) ? (s = t, e) : (n = r.resolve(t.path, i, a), n = _$1.get(Proofs, t.proof).apply(void 0, [n].concat(_toConsumableArray(t.operands))), t.query == Symbols.isnt && (n = !n), o(e, n));
    }, !0);
  }), _defineProperty(_Parsing$1, Mark.Conclusion, function (e, t, n) {
    return e.value.condition ? e.value.success : e.value.failure;
  }), _Parsing$1)
},
    select$1 = function select$1(e) {
  e = e && e.join("");
  var n = Mark.Stamp(Mark.Reference, {
    path: e
  });
  return n.from = function (e) {
    var t = _objectSpread2(_objectSpread2({}, n), {}, {
      from: _$1.isArray(null == e ? void 0 : e.raw) ? e.join("") : e
    });

    return t.alongside = function (e) {
      return _objectSpread2(_objectSpread2({}, t), {}, {
        __alongside: e
      });
    }, t.fallback = function (e) {
      return _objectSpread2(_objectSpread2({}, t), {}, {
        __fallback: e
      });
    }, t;
  }, n;
},
    always$1 = function always$1(e) {
  return _$1.isArray(e) && "raw" in e && (e = e.join("")), Mark.Stamp(Mark.Always, {
    become: e
  });
},
    References = {
  Scaffolding: {
    select: select$1,
    always: always$1
  },
  Parsing: (_defineProperty(_Parsing = {}, Mark.Always, function (e, t, n, r, i) {
    return [null, {
      always: e.value.become
    }];
  }), _defineProperty(_Parsing, Mark.Reference, function (e, t, n, r, i) {
    var a = e.value,
        o = e.resolve(a.path, t, n);
    return _$1.isString(a.from) && (a.from = e.resolve(a.from, t, n)), (_$1.isPlainObject(a.from) || _$1.isArray(a.from)) && (o = _$1.get(a.from, o) || (_$1.has(a, "__fallback") ? a.__fallback : Path.Resolve(a.path, [], t, a.from))), _$1.isPlainObject(a.__alongside) && _$1.isPlainObject(o) ? _objectSpread2(_objectSpread2({}, a.__alongside), o) : o;
  }), _Parsing)
},
    request$1 = function request$1(e) {
  e = _$1.isArray(e) ? e.join("") : e;
  var t = Mark.Stamp(Mark.Request, {
    url: e
  });
  return t.configure = function (e) {
    return t.__configuration = e, t;
  }, t.during = function (e) {
    return t.__during = e, t;
  }, t.failure = function (e) {
    return t.__failure = e, t;
  }, t.success = function (e) {
    return t.__success = e, t;
  }, t;
},
    Requests = {
  Scaffolding: {
    request: request$1
  },
  Parsing: _defineProperty({}, Mark.Request, function (t, n, r, i, e) {
    function a(e) {
      return Transistor$1.Switch(e, n, r, i, t.path);
    }

    var o,
        s = Board.Self,
        c = (s.__requests || (s.__requests = {}), t.value),
        u = Path.Parse(c.url, n, r, t.path).join("/"),
        l = "".concat(t.origin.join("/"), ":").concat(u),
        f = s.__requests;
    return f[l] && "during" != (null == (o = f[l]) ? void 0 : o.status) ? a(null == (o = c["__".concat(null == (o = f[l]) ? void 0 : o.status)]) ? void 0 : o.call(c, f[l].data)) : (f[l] || (f[l] = {
      status: "during",
      fetch: fetch(u, _$1.isFunction(c.__configuration) ? c.__configuration(u) : c.__configuration).then(function (e) {
        return e.text();
      }).then(function (e) {
        var t = {
          response: e
        };
        Object.defineProperty(t, "data", {
          enumerable: !0,
          configurable: !0,
          get: function get() {
            try {
              return JSON.parse(e);
            } catch (e) {
              return console.error("Error parsing JSON from URL:", u, e), !1;
            }
          }
        }), f[l] = _objectSpread2(_objectSpread2({}, f[l]), {}, {
          status: "success",
          data: t
        }), s.rerender();
      }).catch(function (e) {
        f[l] = _objectSpread2(_objectSpread2({}, f[l]), {}, {
          status: "failure",
          data: e
        }), s.rerender();
      })
    }), a(c.__during));
  })
},
    transform$1 = function transform$1() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
    t[n] = arguments[n];
  }

  _$1.isArray(t[0]) && "raw" in t[0] && (t = [t[0].join("")]);

  function r(e) {
    return _objectSpread2(_objectSpread2({}, i), {}, {
      into: e
    });
  }

  var i = Mark.Stamp(Mark.Transform, {
    paths: t
  });
  return _$1.each(i, function (e, t) {
    return r[t] = e;
  }), r;
},
    Transformations = {
  Scaffolding: {
    transform: transform$1
  },
  Parsing: _defineProperty({}, Mark.Transform, function (t, n, r, e) {
    var i = t.value,
        a = i.paths.map(function (e) {
      return t.resolve(e, n, r);
    }),
        i = i.into.apply(i, _toConsumableArray(a));
    return Transistor$1.Switch(i, n, r, e, t.path);
  })
},
    Transistor = function () {
  function c(e) {
    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [],
        n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : [];
    _classCallCheck(this, c), this.origin = t, this.prefix = n, this.location = Path.Locate(e, t), this.path = n.concat(this.location);
  }

  return _createClass(c, [{
    key: "value",
    get: function get() {
      return _$1.cloneDeep(_$1.isEmpty(this.origin) ? this.medium : _$1.get(this.medium, this.origin));
    }
  }, {
    key: "resolve",
    value: function value(e, t, n) {
      return Path.Resolve(e, this.path, t, n);
    }
  }, {
    key: "conduct",
    value: function value(e) {
      var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          n = 2 < arguments.length ? arguments[2] : void 0,
          r = 3 < arguments.length ? arguments[3] : void 0;
      return this.medium = e, this.type = Mark.Type(this.value), this.type != Mark.None && this.type in c.Parsers ? c.Parsers[this.type](this, t, n, r) : this.value;
    }
  }], [{
    key: "Switch",
    value: function value(e, r, i, a) {
      var o = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : [],
          s = 5 < arguments.length ? arguments[5] : void 0,
          t = (e = Schemata.Unfurl(e, r, i), o = Path.Subparse(o, r, i), c.Scan(e, r, o));
      return _$1.isEmpty(t) ? e : _$1.reduce(t, function (e, t) {
        var n;
        return (_$1.isEmpty(t.origin) || _$1.has(e, t.origin)) && (n = t.conduct(e, r, i, a), _$1.isFunction(n) && Mark.Valid(n) && (n = _$1.mapValues(n, function (e) {
          return e;
        })), n = c.Switch(n, r, i, a, o, s), e = _$1.isEmpty(t.origin) ? n : _$1.set(e, t.origin, n)), e;
      }, _$1.cloneDeep(e));
    }
  }]), c;
}(),
    Transistor$1 = (_defineProperty(Transistor, "Scan", function (i) {
  var e,
      a = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      o = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : [],
      t = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : [],
      n = _$1.last(t);

  return "__contents" == n || "contents" == n && Mark.is(_$1.get(i, _$1.initial(t)), Mark.Component) ? [] : (n = _$1.isEmpty(t) ? i : _$1.get(i, t), e = function e(n, r) {
    return _$1.reduce(Object.keys(n), function (e, t) {
      return e.concat(Transistor.Scan(i, a, o, r.concat(_$1.isArray(n) ? parseInt(t) : t)));
    }, []);
  }, Mark.Valid(n) ? _$1.concat(e(n, t), new Transistor(i, t, o)) : _$1.isPlainObject(n) || _$1.isArray(n) ? e(n, t) : []);
}), Transistor.Scaffolding = function (e) {
  return {
    Components: Components.Scaffolding,
    Conditions: Conditional.Scaffolding(e.proofs),
    References: References.Scaffolding,
    Requests: Requests.Scaffolding,
    Transformations: Transformations.Scaffolding
  };
}, Transistor.Parsers = (_defineProperty(_Transistor$Parsers = {}, Mark.Definition, Components.Parsing.Definition), _defineProperty(_Transistor$Parsers, Mark.Component, Components.Parsing.Component), _defineProperty(_Transistor$Parsers, Mark.Statement, Conditional.Parsing.Statement), _defineProperty(_Transistor$Parsers, Mark.Conclusion, Conditional.Parsing.Conclusion), _defineProperty(_Transistor$Parsers, Mark.Always, References.Parsing.Always), _defineProperty(_Transistor$Parsers, Mark.Reference, References.Parsing.Reference), _defineProperty(_Transistor$Parsers, Mark.Request, Requests.Parsing.Request), _defineProperty(_Transistor$Parsers, Mark.Transform, Transformations.Parsing.Transform), _Transistor$Parsers), Transistor),
    Scaffolding = function Scaffolding() {
  var e = Transistor$1.Scaffolding(0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}),
      t = e.Components.define,
      n = e.Components.ui,
      r = e.Components.board,
      i = e.Conditions.is,
      a = e.Conditions.isnt,
      o = e.Conditions.when,
      s = e.References.always,
      c = e.References.select,
      u = e.Requests.request,
      l = e.Transformations.transform;
  return _objectSpread2(_objectSpread2({}, e), {}, {
    define: t,
    ui: n,
    board: r,
    is: i,
    isnt: a,
    when: o,
    always: s,
    select: c,
    request: u,
    transform: l,
    Validate: {
      get Present() {
        return a.present.then("This field is required.");
      },

      get Email() {
        return i.present.and.isnt.email.then("This field requires a valid email address.");
      },

      get Link() {
        return i.present.and.isnt.link.then("This field requires a valid link.");
      },

      get Zip() {
        return i.present.and.isnt.zip.then("This field requires a valid Zip Code.");
      },

      get Phone() {
        return i.present.and.isnt.phone.then("This field requires a valid Phone Number.");
      },

      get Checked() {
        return a.equal.to(!0).then("This field is required.");
      },

      Maximum: function Maximum(e) {
        return i.present.and.is.above(e).then("This field mustn't have more than ".concat(e, " characters."));
      },
      Minimum: function Minimum(e) {
        return i.present.and.is.below(e).then("This field mustn't have less than ".concat(e, " characters."));
      }
    }
  });
},
    Globals = (_.each(Scaffolding(), function (e, t) {
  return Scaffolding[t] = e;
}), function () {
  function r(e) {
    var n = this;
    _classCallCheck(this, r), this.origin = {}, this.defined = _.keys(e), _.each(e, function (e, t) {
      void 0 !== globalThis[t] && (n.origin[t] = globalThis[t]), globalThis[t] = e;
    });
  }

  return _createClass(r, [{
    key: "detach",
    value: function value() {
      var t = this;

      _.each(this.defined, function (e) {
        if (e in t.origin) return globalThis[e] = t.origin[e];
        delete globalThis[e];
      });
    }
  }], [{
    key: "Attached",
    value: function value(e, t) {
      t = new r(t), e = e();
      return t.detach(), e;
    }
  }]), r;
}()),
    Library = function () {
  function l() {
    _classCallCheck(this, l);
  }

  return _createClass(l, null, [{
    key: "Prepare",
    value: function value(a) {
      var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [],
          o = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : function (e) {
        return e;
      },
          s = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : Globals.Attached,
          c = _.mapValues(l.Staggers, function () {
        return new Object();
      }),
          u = function n() {
        var r = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [],
            i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : new WeakSet(),
            t = Schemata.Clone(_.isEmpty(r) ? a : _.get(a, r));

        if (Mark.is(t, Mark.Type.Definition)) {
          var e = _.intersection(_.keys(t), _.keys(l.Staggers));

          if (_.some(e)) return _.each(e, function (e) {
            return c[e][r.join(".")] = t[e];
          }), t;
        }

        return !_.isFunction(t) && !_.isPlainObject(t) || Mark.Valid(t) || i.has(t) ? t : (i.add(t), !_.isPlainObject(t) || /*#__PURE__*/React.isValidElement(t) || Mark.Valid(t) ? _.reduce(_objectSpread2(_objectSpread2({}, _.mapValues(t, function (e, t) {
          return n(r.concat(t), i);
        })), {}, {
          __connected: !0
        }), function (e, t, n) {
          return e[n] = t, e;
        }, o(t)) : _.mapValues(t, function (e, t) {
          return Schemata.Clone(n(r.concat(t), i));
        }));
      }(i);

      return _.each(c, function (e, r) {
        return _.each(e, function (e, t) {
          var n = _.isEmpty(i) ? u : _.set(a, i, u);
          t = _.isEmpty(t) ? [] : t.split("."), s(function () {
            return u = l.Staggers[r](n, t, e, _.get(n, t), o);
          }, {
            UI: n,
            path: t
          });
        });
      }), u;
    }
  }]), l;
}(),
    Schemata = (_defineProperty(Library, "Staggers", {
  get: function get(e, t, n, r) {
    return Object.defineProperty(1 == t.length ? e : _.get(e, _.initial(t)), _.last(t), {
      get: function get() {
        return n(r, t);
      }
    });
  },
  raw: function raw(e, t, n, r) {
    return _.set(e, t, _.isFunction(n) ? n(r, t) : n);
  },
  prepare: function prepare(e, t, n, r, i) {
    return _.set(e, t, _.reduce(r, function (e, t, n) {
      return n in e ? e : _.set(e, n, t);
    }, Library.Prepare(_.set(e, t, define(r.displayName || "Prepared[".concat(t.join("/"), "]"))(r.version || "0.0.1")(n(r, t))), t, i)));
  },
  batch: function batch(e, r, t, i, a) {
    return _.reduce(_.isFunction(t) ? t(i, r) : t, function (e, t, n) {
      return _.set(e, n, Library.Prepare(_.set(e, _.initial(r).concat(n), Mark.is(t, Mark.Definition) ? t : define(n)(i.version || "0.0.1")(t)), _.initial(r).concat(n), a));
    }, _.omit(e, r));
  }
}), function () {
  function a(e, t) {
    _classCallCheck(this, a), this.schematic = e, this.component = e, this.parameters = {}, _.isArray(e) && (this.component = e[0], this.parameters = e[1] || {}), this.parameters = _objectSpread2(_objectSpread2(_objectSpread2({}, a.DEFAULTS), this.parameters), t), this.present = !(!1 === this.component || void 0 === this.component), this.hidden = !this.present || !this.parameters.visible, this.junction = _.isPlainObject(this.component) && ! /*#__PURE__*/React.isValidElement(this.component);
  }

  return _createClass(a, null, [{
    key: "Clone",
    value: function value(e) {
      return _.cloneDeepWith(e, function (e) {
        var t, n;
        if (_.isFunction(e)) return t = _.mapValues(e, function (e) {
          return a.Clone(e);
        }), n = e.bind({}), _.each(t, function (e, t) {
          return n[t] = e;
        }), n;
      });
    }
  }, {
    key: "Unfold",
    value: function value(e) {
      var n, t, r;
      return _.isArray(e) ? (r = e[0], n = e[1] || {}, _.isArray(r) && (r = (t = a.Unfold(r)).component, _.each(t.parameters, function (e, t) {
        return _.isArray(e) && _.isArray(n[t]) ? n[t] = n[t].concat(e) : _.isPlainObject(e) && _.isPlainObject(n[t]) ? n[t] = _.merge({}, e, n[t]) : void (t in n || (n[t] = e));
      })), {
        component: r,
        parameters: n
      }) : {
        component: e,
        parameters: {}
      };
    }
  }, {
    key: "Unwrap",
    value: function value(e) {
      var t;
      return _.isPlainObject(e) ? _.mapValues(e, function (e, t) {
        return Path.Subschema(t) ? e : a.Unwrap(e);
      }) : _.isArray(e) ? (t = a.Unfold(e), [a.Unwrap(t.component), t.parameters]) : e;
    }
  }, {
    key: "Unfurl",
    value: function value(n) {
      var e,
          r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          i = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
      return _.isArray(n) ? n.map(function (e) {
        return a.Unfurl(e, r, i);
      }) : Mark.Valid(n) || /*#__PURE__*/React.isValidElement(n) || !_.isPlainObject(n) && !_.isFunction(n) ? n : (e = _.mapValues(n), _.each(e, function (e, t) {
        return delete n[t];
      }), _.reduce(e, function (e, t, n) {
        n = Path.Parse(n, r, i);
        return 1 < n.length && (n[0] = fix(n[0])), _.setWith(e, n, a.Unfurl(t, r, i), Object);
      }, n));
    }
  }, {
    key: "Parse",
    value: function value(e) {
      return a.Unwrap(Transistor$1.Switch(e, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {}, 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {}, 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : []));
    }
  }]), a;
}()),
    _excluded = (_defineProperty(Schemata, "DEFAULTS", {
  visible: !0,
  showErrors: !0,
  validation: []
}), ["visible", "validation", "showErrors", "__definition", "__contents", "child", "socket"]),
    bind = Function.prototype.bind,
    Context = (Object.defineProperty(Function.prototype, "bind", {
  value: function value() {
    var e = bind.apply(this, arguments);
    return e.__source = this.__source || this, e;
  }
}), /*#__PURE__*/React.createContext()),
    Circuit = function () {
  _inherits(a, React.Component);

  var n = _createSuper(a);

  function a(e) {
    var t,
        r,
        i = this;
    return _classCallCheck(this, a), (r = n.call(this, e)).detach = r.detach.bind(_assertThisInitialized(r)), r.attach = r.attach.bind(_assertThisInitialized(r)), r.attached = r.attached.bind(_assertThisInitialized(r)), r.parse = r.parse.bind(_assertThisInitialized(r)), r.change = r.change.bind(_assertThisInitialized(r)), r.default = r.default.bind(_assertThisInitialized(r)), r.migrate = r.migrate.bind(_assertThisInitialized(r)), r.field = r.field.bind(_assertThisInitialized(r)), r.junction = r.junction.bind(_assertThisInitialized(r)), r.component = r.component.bind(_assertThisInitialized(r)), r.Socket = r.Socket.bind(_assertThisInitialized(r)), r.Subschema = r.Subschema.bind(_assertThisInitialized(r)), r.Contents = r.Contents.bind(_assertThisInitialized(r)), r.scope = {}, r.versions = (null == (t = r.props.value) ? void 0 : t.__versions) || {}, r.schematic = Schemata.Clone(_$1.isFunction(e.schematic) ? _defineProperty({}, Schematic._, e.schematic) : e.schematic), r.methods = new Map(), r.library = Library.Prepare(r.props.components, [], function (n) {
      return function (e) {
        var t = useContext(Context),
            t = ("children" in e && (t.contents = e.children), "contents" in e && (t.contents = e.contents), r.attach(t), /*#__PURE__*/React.isValidElement(n) ? function (e) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, _objectSpread2(_objectSpread2({}, n), {}, {
            props: _objectSpread2(_objectSpread2({}, n.props), e)
          }));
        } : _$1.isPlainObject(n) ? /*#__PURE__*/React.createElement(i.Subschema, {
          schematic: n
        }) : n);
        return /*#__PURE__*/React.createElement(t, e);
      };
    }, r.attached), r;
  }

  return _createClass(a, [{
    key: "floor",
    get: function get() {
      return this.props.path || [];
    }
  }, {
    key: "socket",
    get: function get() {
      return this.props.socket || this.Socket;
    }
  }, {
    key: "parameters",
    get: function get() {
      return _objectSpread2(_objectSpread2({}, this.props.parameters || {}), this.props.overrides || {});
    }
  }, {
    key: "change",
    value: function value(e) {
      this.props.onChange(e, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [], 2 < arguments.length ? arguments[2] : void 0, 3 < arguments.length ? arguments[3] : void 0);
    }
  }, {
    key: "default",
    value: function value(e) {
      this.change(e, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [], void 0, !0);
    }
  }, {
    key: "migrate",
    value: function value(e, t, n) {
      this.versions[t.join(".")] != n && (this.versions[t.join(".")] = n, this.change(_$1.set(_$1.set(this.props.value, t, e), "__versions", this.versions), [], void 0, !0));
    }
  }, {
    key: "field",
    value: function value(e, t) {
      return "".concat(_$1.castArray(e).map(function (e) {
        return "[".concat(e, "]");
      }).join("")).concat(t ? "[".concat(t, "]") : "");
    }
  }, {
    key: "junction",
    value: function value(n, r) {
      var i = this,
          a = -1;
      return n.hidden ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(React.Fragment, null, _$1.map(n.component, function (e, t) {
        return a++, i.component(new Schemata(e, {
          socket: n.parameters.socket,
          showErrors: i.parameters.showErrors
        }), t, r, 0 == a, a == _$1.keys(n.component).length - 1);
      }));
    }
  }, {
    key: "component",
    value: function value(e, t, n, r, i) {
      var a,
          o,
          s = this,
          c = (t = Schematic.fixedFieldName(t), n = Schematic.fixedFieldName(n), e.parameters),
          u = (c.visible, c.validation),
          l = c.showErrors,
          f = c.__definition,
          d = c.__contents,
          p = (c.child, c.socket),
          c = _objectWithoutProperties(c, _excluded),
          h = (delete c.default, {
        relative: n.concat(t),
        absolute: this.floor.concat(n),
        self: this.floor.concat(n).concat(t),
        framing: this.floor.concat(n).concat(t).join(".")
      }),
          _ = this.field(h.absolute, t),
          m = _$1.isEmpty(h.relative) ? this.props.value : _$1.get(this.props.value, h.relative);

      return void 0 !== e.parameters.always ? e.parameters.always != m && (m = e.parameters.always, this.change(e.parameters.always, h.relative)) : void 0 === m && void 0 !== e.parameters.default ? (m = e.parameters.default, this.default(e.parameters.default, h.relative)) : null != f && f.version && (a = null == f ? void 0 : f.version, o = _$1.get(this.props.value.__versions, h.framing) || "0.0.0", semver.gt(o, a) && console.warn("Value at ".concat(h.relative.join("/"), " is versioned higher [ ").concat(o, " ] than the available version [ ").concat(a, " ]")), semver.lt(o, a)) && f.migrations && this.migrate(_$1.reduce(f.migrations, function (e, t, n) {
        return semver.lte(n, a) && semver.gt(n, o) ? t(e) : e;
      }, m), h.relative, a), this.props.evaluating && void 0 === m && void 0 === e.parameters.default && this.default(null, h.relative), this.wireframe.presence[h.framing] = !e.hidden, e.hidden || _$1.isEmpty(u) || (this.wireframe.errors[h.framing] = u), null == e.component ? null : (f = p || this.socket, p = {
        path: h.self,
        contents: d,
        Subschema: this.Subschema,
        Contents: this.Contents
      }, this.attach(p), m = _objectSpread2({
        key: this.field(h.absolute, t),
        UI: globalThis.UI,
        Board: globalThis.Board,
        Subschema: this.Subschema,
        Contents: this.Contents,
        contents: d,
        onChange: function onChange(e) {
          return s.change(e, h.relative);
        },
        path: h.self,
        name: this.field(h.absolute, t),
        value: m,
        overrides: null == (d = this.parameters) ? void 0 : d.child,
        first: r,
        last: i
      }, c), e.hidden ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(f, {
        Component: e.junction ? this.junction(e, h.relative) : /*#__PURE__*/React.createElement(Context.Provider, {
          value: p
        }, /*#__PURE__*/React.isValidElement(e.component) ? _objectSpread2(_objectSpread2({}, e.component), {}, {
          props: _objectSpread2(_objectSpread2({}, e.component.props), m)
        }) : /*#__PURE__*/React.createElement(e.component, m)),
        name: t,
        key: m.key,
        field: _,
        location: n,
        descriptor: e,
        parameters: e.parameters,
        validation: l ? u : [],
        wireframe: this.wireframe,
        first: r,
        last: i
      }));
    }
  }, {
    key: "parse",
    value: function value(e) {
      var o = this,
          s = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [],
          c = 2 < arguments.length ? arguments[2] : void 0,
          s = Schematic.fixedFieldName(s),
          c = Schematic.fixedFieldName(c);
      s = s.map(function (e) {
        return _$1.toString(e);
      });
      var t = new Schemata(Schemata.Parse(function n(e) {
        var t,
            a = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [];
        return /*#__PURE__*/React.isValidElement(e) ? e : _$1.isPlainObject(e) ? _$1.mapValues(e, function (e, t) {
          return n(e, a.concat(t));
        }) : _$1.isArray(e) ? (t = function n(e) {
          function r(r, e) {
            var t;
            return ["contents", "socket"].includes(e) || (_$1.isPlainObject(r) || _$1.isFunction(r)) && Mark.Valid(r) ? r : _$1.isPlainObject(r) ? n(r, i.concat(e)) : !_$1.isFunction(r) || "__connected" in r ? r : (e = "[".concat(s.concat(c).concat(a).concat(i).concat(e).join("."), "]:").concat(r.__source || r), o.methods.has(e) ? o.methods.get(e) : ((t = function t() {
              for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
                t[n] = arguments[n];
              }

              return o.attached(function () {
                return r.apply(void 0, t);
              }, {
                path: s.concat(c)
              });
            }).__connected = !0, o.methods.set(e, t), t));
          }

          var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [];
          return /*#__PURE__*/React.isValidElement(e) || (_$1.isPlainObject(e) || _$1.isFunction(e)) && Mark.Valid(e) ? e : _$1.isArray(e) ? _$1.map(e, r) : _$1.isPlainObject(e) ? _$1.mapValues(e, r) : _$1.isFunction(e) ? _$1.reduce(e, function (e, t, n) {
            return e[n] = r(t, n), e;
          }, e) : e;
        }, e.map(function (e) {
          return t(e);
        })) : e;
      }(e), this.props.variables, this.props.value, this.library, _$1.isEmpty(c) ? s : s.concat(c)), _objectSpread2(_objectSpread2({}, this.parameters), {}, {
        showErrors: null == (t = this.parameters) ? void 0 : t.showErrors
      }));
      return t.junction ? this.junction(t, c && !_$1.isEmpty(s) ? s.concat(c) : s) : this.component(t, c, s);
    }
  }, {
    key: "detach",
    value: function value() {
      this.globals && this.globals.detach(), this.globals = void 0;
    }
  }, {
    key: "attach",
    value: function value() {
      var i = this,
          a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
          r = a.path,
          e = _objectSpread2({
        UI: this.library,
        Subschema: this.Subschema,
        Contents: this.Contents
      }, a);

      Object.defineProperty(e, "Board", {
        enumerable: !0,
        configurable: !0,
        get: function get() {
          function n(r) {
            return function () {
              for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
                t[n] = arguments[n];
              }

              return i.attached(function () {
                return r.apply(void 0, t);
              }, a);
            };
          }

          _$1.each(i.props.variable(), function (e, t) {
            return n[t] = e;
          }), n.Path = r, n.Set = i.props.variable.set, n.Change = function (e, t, n) {
            return i.change(e, t || r, n);
          }, n.Evaluate = function (e) {
            return i.attached(function () {
              return i.props.evaluate(e);
            }, a);
          }, n.Self = i.props.board, n.Scope = i.scope;
          return Object.defineProperty(n, "Value", {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return e = i.props.value, n = {}, _$1.each(e, function (e, t) {
                Object.defineProperty(n, t, {
                  enumerable: !0,
                  configurable: !0,
                  value: e,
                  writable: !1
                });
              }), n;
              var e, n;
            }
          }), n;
        }
      }), this.detach(), this.scope = e, this.globals = new Globals(e);
    }
  }, {
    key: "attached",
    value: function value(e) {
      return this.attach(1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}), e(this.scope);
    }
  }, {
    key: "Socket",
    value: function value(e) {
      var t = e.Component;
      return e.path, e.name, e.parameters, e.validation, t;
    }
  }, {
    key: "Subschema",
    value: function value(e) {
      var t = e.schematic,
          n = e.field,
          n = void 0 === n ? [] : n,
          r = e.socket,
          e = e.children,
          n = _$1.isArray(n) ? n.map(function (e) {
        return _$1.toString(e);
      }) : _$1.toString(n),
          i = useContext(Context);
      return this.parse([e || t, r ? {
        socket: r
      } : {}], i.path, n);
    }
  }, {
    key: "Contents",
    value: function value(e) {
      var n = this,
          t = e.field,
          r = void 0 === t ? [] : t,
          i = e.socket,
          r = _$1.isArray(r) ? r.map(function (e) {
        return _$1.toString(e);
      }) : _$1.toString(r),
          a = useContext(Context);
      return !_$1.isPlainObject(a.contents) || /*#__PURE__*/React.isValidElement(a.contents) || Mark.Valid(a.contents) ? this.parse([a.contents, i ? {
        socket: i
      } : {}], a.path, r) : _$1.map(a.contents, function (e, t) {
        return n.parse([e, i ? {
          socket: i
        } : {}], a.path.concat(r), t);
      });
    }
  }, {
    key: "render",
    value: function value() {
      var e, t;
      if (_$1.isEmpty(this.schematic)) return /*#__PURE__*/React.createElement(React.Fragment, null);
      this.wireframe = {
        errors: {},
        presence: {},
        versions: this.versions
      };
      var n = this.parse(this.schematic);
      return null != (e = (t = this.props).onScan) && e.call(t, this.wireframe), n;
    }
  }]), a;
}(),
    Path = function () {
  function a() {
    _classCallCheck(this, a);
  }

  return _createClass(a, null, [{
    key: "Locate",
    value: function value(r, i) {
      i = Schematic.fixedFieldName(i);

      var a = Mark.Type(r) == Mark.Reference ? 2 : 0,
          e = _$1.reduce(i, function (e, t, n) {
        if (0 < a) a--;else {
          n = i.slice(0, n), n = _$1.isEmpty(n) ? r : _$1.get(r, n), n = Mark.Type(n);
          if (n == Mark.None) return e.concat(t);
          n != Mark.Reference && n != Mark.Definition || (a = 1);
        }
        return e;
      }, []);

      return e = (e = -1 == e.indexOf(1) ? e : e.slice(0, e.indexOf(1))).filter(function (e) {
        return !_$1.isNumber(e);
      });
    }
  }, {
    key: "Prepare",
    value: function value(e) {
      return _$1.isString(e) ? e.split(a.Symbols.delimiter) : _$1.isArray(e) ? e : [""];
    }
  }, {
    key: "Subsplit",
    value: function value(e) {
      return e.split(a.Symbols.subdelimiter).map(function (e) {
        return a.Symbolic(e) ? e.substr(1) : e;
      });
    }
  }, {
    key: "Parse",
    value: function value(e) {
      var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
          r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : [];
      return a.Prepare(e).map(function (e) {
        return a.Variable(e) ? _$1.toString(_$1.get(t, a.Subsplit(e))) : a.Context(e) ? _$1.toString(_$1.get(n, a.Apply(a.Subsplit(e), r, t, n))) : e;
      });
    }
  }, {
    key: "Subparse",
    value: function value(e) {
      var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          r = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
      return _$1.reduce(a.Parse(e, n, r), function (e, t) {
        return e.concat(a.Parse(t, n, r));
      }, []);
    }
  }, {
    key: "Apply",
    value: function value(e, t) {
      var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
          r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {},
          i = a.Subparse(e, n, r);
      return _$1.isEmpty(_$1.first(i)) && (t = []), _$1.reduce(i, function (e, t) {
        return _$1.isEmpty(t) || a.Relative(t) ? e : a.Back(t) ? _$1.initial(e) : e.concat(t);
      }, a.Subparse(t, n, r));
    }
  }, {
    key: "Resolve",
    value: function value(e) {
      var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [],
          n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {},
          r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {},
          i = a.Prepare(e);
      return a.Variable(i[0]) ? _$1.get(n, _$1.reduce(i, function (e, t) {
        return e.concat(a.Subsplit(t));
      }, [])) : _$1.get(r, a.Apply(i, t, n, r));
    }
  }, {
    key: "Subschema",
    value: function value(e) {
      return ["__contents", "contents"].includes(e);
    }
  }, {
    key: "Symbolic",
    value: function value(e) {
      return a.Variable(e) || a.Context(e);
    }
  }, {
    key: "Variable",
    value: function value(e) {
      return !_$1.isEmpty(e) && e.startsWith(a.Symbols.variable);
    }
  }, {
    key: "Context",
    value: function value(e) {
      return !_$1.isEmpty(e) && e.startsWith(a.Symbols.context);
    }
  }, {
    key: "Relative",
    value: function value(e) {
      return !_$1.isEmpty(e) && e == a.Symbols.relative;
    }
  }, {
    key: "Back",
    value: function value(e) {
      return e == a.Symbols.back;
    }
  }]), a;
}(),
    Board$1 = (_defineProperty(Path, "Symbols", {
  variable: "~",
  context: "@",
  delimiter: "/",
  subdelimiter: ":",
  relative: ".",
  back: ".."
}), function () {
  _inherits(l, React.Component);

  var t = _createSuper(l);

  function l(e) {
    var o;
    return _classCallCheck(this, l), (o = t.call(this, e)).state = {
      __value: e.initial ? _$1.cloneDeep(e.initial) : {},
      __variables: {}
    }, o.wireframe = {}, o.valid = !1, o.evaluate = o.evaluate.bind(_assertThisInitialized(o)), o.variable = function () {
      return function r(i) {
        var a = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [];
        return _$1.reduce(i, function (e, t, n) {
          return _$1.isPlainObject(t) && !Mark.Valid(i) ? e[n] = r(t, a.concat(n)) : Object.defineProperty(e, n, {
            enumerable: !0,
            configurable: !0,
            get: function get() {
              return _$1.isPlainObject(t) ? _$1.cloneDeep(t) : t;
            },
            set: function set(e) {
              return o.setState({
                __variables: _$1.set(o.state.__variables, a.concat(n), e)
              });
            }
          }), e;
        }, {});
      }(o.variables);
    }, o.variable.set = function (e, t) {
      return o.setState({
        __variables: _$1.merge({}, o.state.__variables, e)
      }, t);
    }, o.circuit = function (e) {
      return /*#__PURE__*/React.createElement(Circuit, _extends({
        board: _assertThisInitialized(o),
        schematic: o.props.schematic || function () {
          return /*#__PURE__*/React.createElement(React.Fragment, null);
        },
        variables: o.variables,
        variable: o.variable,
        name: o.props.name || "",
        value: o.value,
        evaluate: o.evaluate,
        onChange: function onChange(e, t, n, r) {
          return o.push(_$1.isEmpty(t) ? e : _$1.set(o.value, t, e), t, n, r);
        },
        onScan: function onScan(e) {
          var t, n;
          o.wireframe = e, null != (t = (n = o.props).onScan) && t.call(n, e);
        },
        child: o.props.child,
        components: o.props.components,
        socket: o.props.socket
      }, e, {
        parameters: _objectSpread2(_objectSpread2(_objectSpread2({
          showErrors: !1
        }, o.state.__parameters), e.parameters), o.props.parameters)
      }));
    }, o.circuit.reset = function () {
      o.setState({
        __value: e.initial,
        __variables: void 0,
        __parameters: void 0
      }), o.valid = !1, o.wireframe = {};
    }.bind(_assertThisInitialized(o)), o.validate = o.validate.bind(_assertThisInitialized(o)), o;
  }

  return _createClass(l, [{
    key: "controlled",
    get: function get() {
      return void 0 !== this.props.value;
    }
  }, {
    key: "value",
    get: function get() {
      return this.controlled ? this.props.value : this.state.__value;
    }
  }, {
    key: "variables",
    get: function get() {
      return _$1.merge({}, this.props.variables, this.state.__variables);
    }
  }, {
    key: "product",
    get: function get() {
      return _$1.reduce(this.wireframe.presence, function (e, t, n) {
        return t || _$1.unset(e, n), e;
      }, _$1.cloneDeep(this.value));
    }
  }, {
    key: "push",
    value: function value(e, n, r, i) {
      var t,
          a,
          o = this;
      this.controlled ? this.props.onChange ? (null != (t = (a = this.props).onChange) && t.call(a, e, n, void 0, i), this.callback = r) : null != r && r() : this.setState({
        __value: e
      }, function () {
        var e, t;
        null != (e = (t = o.props).onChange) && e.call(t, o.state.__value, n, i), null != r && r();
      });
    }
  }, {
    key: "evaluate",
    value: function value(e) {
      return this.constructor.Evaluate(e, 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, this.props.components, this.variables, this.variable, _objectSpread2(_objectSpread2({}, this.state.__parameters), this.props.parameters), this.props.socket);
    }
  }, {
    key: "rerender",
    value: function value() {
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function value() {
      return this.callback && (this.callback(), this.callback = null), /*#__PURE__*/React.createElement(this.circuit, null);
    }
  }, {
    key: "validate",
    value: function value() {
      return this.setState({
        __parameters: _objectSpread2(_objectSpread2({}, this.state.__parameters), {}, {
          showErrors: !0
        })
      }), this.valid = _$1.isEmpty(this.wireframe.errors), this.valid;
    }
  }], [{
    key: "Evaluate",
    value: function value(e) {
      function t() {
        return a ? a() : i;
      }

      var n = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
          r = 2 < arguments.length ? arguments[2] : void 0,
          i = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : {},
          a = 4 < arguments.length ? arguments[4] : void 0,
          o = 5 < arguments.length && void 0 !== arguments[5] ? arguments[5] : {},
          s = 6 < arguments.length ? arguments[6] : void 0,
          c = _objectSpread2({}, globalThis.Board.Scope),
          u = {};

      return t.set = function () {}, ReactDOMServer.renderToString( /*#__PURE__*/React.createElement(Circuit, {
        evaluating: !0,
        board: {},
        evaluate: function evaluate(e) {
          return l.Evaluate(e, n, r, i, a, o, s);
        },
        schematic: e,
        variables: i,
        variable: t,
        value: u,
        onChange: function onChange(e, t, n) {
          u = _$1.isEmpty(t) ? e : _$1.set(u, t, e), null != n && n();
        },
        components: r,
        socket: s,
        parameters: _objectSpread2({
          showErrors: !1
        }, o)
      })), _$1.each(c, function (e, t) {
        return globalThis[t] = e;
      }), _$1.merge({}, n, u);
    }
  }]), l;
}()),
    Schematic = {
  NullFieldPrefix: "nullfield_",
  isNullField: function isNullField(e) {
    return _$1.startsWith(e, Schematic.NullFieldPrefix);
  },

  get _() {
    return "".concat(Schematic.NullFieldPrefix).concat(v4());
  },

  FixedFieldPrefix: "fixedfield_",
  isFixedField: function isFixedField(e) {
    return _$1.startsWith(e, Schematic.FixedFieldPrefix);
  },
  fixedFieldName: function fixedFieldName(e) {
    return _$1.isArray(e) ? _$1.map(e, Schematic.fixedFieldName) : Schematic.isFixedField(e) && e.split("|")[1] || e;
  },
  fix: function fix() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : [];
    return "".concat(Schematic.FixedFieldPrefix).concat(v4(), "|").concat(_$1.castArray(e).join(""));
  }
},
    s = Schematic,
    fix = Schematic.fix,
    define = Scaffolding.define,
    ui = Scaffolding.ui,
    board = Scaffolding.board,
    is = Scaffolding.is,
    isnt = Scaffolding.isnt,
    when = Scaffolding.when,
    always = Scaffolding.always,
    select = Scaffolding.select,
    request = Scaffolding.request,
    transform = Scaffolding.transform;

export { Board$1 as Board, Circuit, Globals, Library, Mark, Path, Scaffolding, Schemata, Schematic, Transistor$1 as Transistor, always, board, define, fix, is, isnt, request, s, select, transform, ui, when };